"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var Price_1 = __importDefault(require("../Price"));
var i18n_1 = __importDefault(require("../../i18n"));
var mediaHelper_1 = require("../../helpers/mediaHelper");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
// Same gradients as the mockup, used when a post has no photo.
var PLACEHOLDER_COUNT = 4;
var CTA_KEY = {
    tours3d: 'CTA_TOUR',
    top: 'CTA_VIEW',
    developer: 'CTA_PLANS',
    secondary: 'CTA_VIEW',
};
var T = 'HOME.LISTING_CARD';
// Search rows return these fields as arrays (one value per entity),
// while IPost types them as strings — accept both and take the first value.
var firstValue = function (value) {
    var raw = Array.isArray(value) ? value[0] : value;
    return raw === null || raw === undefined || raw === ''
        ? undefined
        : String(raw);
};
var HomeListingCard = function (_a) {
    var _b;
    var _c, _d, _e;
    var post = _a.post, variant = _a.variant, index = _a.index, onOpen = _a.onOpen, onToggleBookmark = _a.onToggleBookmark;
    var t = react_i18next_1.useTranslation('common').t;
    var getBadge = function () {
        if (variant === 'tours3d')
            return { text: '🎥 3D', className: styles_module_scss_1.default.badge_3d };
        if (variant === 'top')
            return { text: 'TOP', className: styles_module_scss_1.default.badge_top };
        if (variant === 'developer' && post.developerName) {
            return {
                text: post.developerName,
                className: styles_module_scss_1.default.badge_developer,
            };
        }
        return null;
    };
    // "-1" rooms means a free layout, same as on the search page card.
    var getRoomsText = function () {
        var rooms = firstValue(post.rooms);
        if (!rooms)
            return null;
        if (rooms === '-1')
            return t('POST_CARD.FREE_LAYOUT_DESIGN');
        return t(T + ".ROOMS", { count: Number(rooms) });
    };
    var getFloorText = function () {
        var floor = firstValue(post.floor);
        if (!floor)
            return null;
        var total = firstValue(post.buildingFloors);
        var value = total ? floor + "/" + total : floor;
        // React escapes the text itself; i18next escaping would turn "/" into "&#x2F;".
        return t(T + ".FLOOR", {
            value: value,
            interpolation: { escapeValue: false },
        });
    };
    var getAreaText = function () {
        var area = firstValue(post.area);
        if (!area)
            return null;
        return t(T + ".AREA", { value: area });
    };
    // Translated addresses can end with an empty street part: "Ереван, Кентрон,".
    var address = (_c = post.address) === null || _c === void 0 ? void 0 : _c.replace(/[\s,]+$/, '');
    // 1. Developer cards start with the building name, as in the mockup.
    // 2. Then rooms · area · floor, skipping whatever the post doesn't have.
    var specs = [
        variant === 'developer' ? post.buildingName : null,
        getRoomsText(),
        getAreaText(),
        getFloorText(),
    ].filter(Boolean);
    var badge = getBadge();
    var image = firstValue(post.image);
    return (react_1.default.createElement("a", { className: styles_module_scss_1.default.card, href: "/preview/" + ((_e = (_d = post.slug) === null || _d === void 0 ? void 0 : _d[i18n_1.default.language]) !== null && _e !== void 0 ? _e : ''), onClick: function (e) {
            e.preventDefault();
            onOpen(post);
        } },
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.photo, !image && styles_module_scss_1.default["placeholder_" + index % PLACEHOLDER_COUNT]), style: image
                ? {
                    backgroundImage: "url(\"" + mediaHelper_1.resolveThumbByExtension(image) + "\")",
                }
                : undefined },
            badge && (react_1.default.createElement("span", { className: classnames_1.default(styles_module_scss_1.default.badge, badge.className) }, badge.text)),
            react_1.default.createElement("button", { type: "button", className: classnames_1.default(styles_module_scss_1.default.fav, (_b = {},
                    _b[styles_module_scss_1.default.fav_active] = post.bookmarked,
                    _b)), "aria-label": t(T + ".FAVORITE"), onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    onToggleBookmark(post);
                } }, post.bookmarked ? '♥' : '♡')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.body },
            react_1.default.createElement(Price_1.default, { value: post.priceFull, className: styles_module_scss_1.default.price }),
            specs.length > 0 && (react_1.default.createElement("div", { className: styles_module_scss_1.default.specs }, specs.join(' · '))),
            address && react_1.default.createElement("div", { className: styles_module_scss_1.default.address }, address),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.cta },
                t(T + "." + CTA_KEY[variant]),
                " \u2192"))));
};
exports.default = HomeListingCard;
